/**
 * Desktop app (Tauri): notifications are on by default (TRUS-668), so the OS
 * permission is requested automatically on the first launch after sign-in.
 *
 * ensureDesktopPermissionPrompt is a no-op in the browser (web push asks from a
 * click instead), in pop-out windows, and once the user has decided: macOS and
 * Windows only prompt once, and a later "denied" is shown as a hint in
 * Settings (DesktopNotificationBlockedHint).
 */
import { useEffect, useRef } from 'react';
import { desktopNotifications } from '@/services/desktopNotifications';

export function useDesktopNotificationPermissionOnLogin(signedIn: boolean): void {
  const asked = useRef(false);
  useEffect(() => {
    if (!signedIn) {
      asked.current = false;
      return;
    }
    if (asked.current) return;
    asked.current = true;
    void desktopNotifications.ensureDesktopPermissionPrompt();
  }, [signedIn]);
}
